import type { EditorThemeClasses } from 'lexical'

export const editorTheme: EditorThemeClasses = {
  heading: {
    h1: 'lexical-h1',
    h2: 'lexical-h2',
    h3: 'lexical-h3',
  },
  paragraph: 'lexical-paragraph',
  list: {
    ul: 'lexical-ul',
    ol: 'lexical-ol',
    checklist: 'lexical-checklist',
    listitem: 'lexical-li',
    listitemChecked: 'lexical-li-checked',
    listitemUnchecked: 'lexical-li-unchecked',
    nested: {
      listitem: 'lexical-li-nested',
    },
  },
  quote: 'lexical-blockquote',
  link: 'lexical-link',
  text: {
    bold: 'lexical-bold',
    italic: 'lexical-italic',
    underline: 'lexical-underline',
    strikethrough: 'lexical-strikethrough',
    code: 'lexical-code-inline',
    highlight: 'lexical-highlight',
  },
  code: 'lexical-code-block',
  codeHighlight: {
    atrule: 'lexical-token-attr',
    attr: 'lexical-token-attr',
    boolean: 'lexical-token-property',
    builtin: 'lexical-token-selector',
    cdata: 'lexical-token-comment',
    char: 'lexical-token-selector',
    class: 'lexical-token-function',
    'class-name': 'lexical-token-function',
    comment: 'lexical-token-comment',
    constant: 'lexical-token-property',
    deleted: 'lexical-token-property',
    doctype: 'lexical-token-comment',
    entity: 'lexical-token-operator',
    function: 'lexical-token-function',
    important: 'lexical-token-variable',
    inserted: 'lexical-token-selector',
    keyword: 'lexical-token-attr',
    namespace: 'lexical-token-variable',
    number: 'lexical-token-property',
    operator: 'lexical-token-operator',
    prolog: 'lexical-token-comment',
    property: 'lexical-token-property',
    punctuation: 'lexical-token-punctuation',
    regex: 'lexical-token-variable',
    selector: 'lexical-token-selector',
    string: 'lexical-token-selector',
    symbol: 'lexical-token-property',
    tag: 'lexical-token-property',
    url: 'lexical-token-operator',
    variable: 'lexical-token-variable',
  },
  image: 'lexical-image-wrapper',
  hr: 'lexical-hr',
  table: 'lexical-table',
  tableCell: 'lexical-table-cell',
  tableCellHeader: 'lexical-table-cell-header',
  tableRow: 'lexical-table-row',
  tableCellSelected: 'lexical-table-cell-selected',
  tableScrollableWrapper: 'lexical-table-scroll-wrapper',
  layoutContainer: 'lexical-layout-container',
  layoutItem: 'lexical-layout-item',
  ltr: 'lexical-ltr',
  rtl: 'lexical-rtl',
}
